import React from 'react';
import './Loading.css';

export const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

export const LoadingOverlay = ({ message = '載入中...' }) => (
  <div className="loading-overlay">
    <div className="loading-content">
      <div className="spinner"></div>
      <p>{message}</p>
    </div>
  </div>
);

export const LoadingPage = ({ message = '載入中...' }) => (
  <div className="loading-page">
    <div className="spinner"></div>
    <p>{message}</p>
  </div>
);
